<template>
  <div
    @click.prevent="navigate($event)"
    class="w-full lg:w-1/4 md:w-1/3 sm:w-1/2 sm:p-2 cursor-pointer"
  >
    <div class="border rounded-lg">
      <div class="flex items-center justify-center flex-col bg-card mb-4">
        <div class="w-full mb-8 text-right p-2"></div>
        <div class="mb-8">
          <i class="far fa-sticky-note fa-3x text-white"></i>
        </div>
      </div>
      <div class="px-6">
        <h5 class="text-xl font-semibold tenant-main-color">
          {{ data.course.title }}
        </h5>
        <div class="flex justify-between tenant-main-color my-4">
          <p
            @click="navigate(data.id)"
            class="text-sm font-semibold cursor-pointer"
          >
            View Note ->
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  name: "survey-card",
  props: ["data"],
  methods: {
    ...mapActions(["tenantDeleteSurvey"]),
    navigate(e) {
      e.stopImmediatePropagation();
      this.$router.push({
        name: "learner-notes-single",
        params: { id: this.data.id },
      });
    },
  },
};
</script>
<style lang="scss">
.bg-card {
  background-color: color(lms-tenant);
}
</style>
